import React from 'react'
import './Footer.css'
import { Link } from "react-router-dom"; 
import footer_logo from '../Assets/logo1.png'
import instagram_icon from '../Assets/instagram_icon.png'
import pintester_icon from '../Assets/pintester_icon.png'
import whatsapp_icon from '../Assets/whatsapp_icon.png'

const Footer = () => {
  return (
    <div className='footer'>
      <div className="footer-logo">
        <img src={footer_logo} alt=""/>
        <p>SARATHI</p>
      </div>
      <ul className="footer-links">
      <li className='link'><Link to="/">Company</Link></li>  
        <li className='link'><Link to="/">Products</Link></li>
        <li className='link'><Link to="/about">About</Link></li>  
        <li className="link">
          <a  href="mailto:himanshirana2403@gmail.com">Contact</a>
        </li>
      </ul>
      <div className="footer-social-icon">
        <div className="footer-icons-container">
          <img src={instagram_icon} alt="Instagram"/>
        </div>
        <div className="footer-icons-container">
          <img src={pintester_icon} alt="Pinterest"/>
        </div>
        <div className="footer-icons-container">
          <img src={whatsapp_icon} alt="WhatsApp"/>
        </div>
      </div>
      <div className="footer-copyright">
        <hr />
        <p>Designed and Developed with ❤️ </p>
        <p>Copyright © 2025 Sarathi. All rights reserved.</p>
      </div>
    </div>
  )
}

export default Footer
